module.exports = __webpack_public_path__ + "img/sparkles.5407e729.svg";